export const getInvitationDataSelector = (state) =>
  state.friendReferReducer.data;

export const isInvitaionDataLoading = (state) =>
  state.friendReferReducer.isLoading;
